export const FAQs = [
	{
		title: "What types of drinks do you offer?",
		content:
			"We offer a wide range of soft drinks including classic sodas, fruit-infused drinks, and more.",
	},
	{
		title: "Do you sell in bulk",
		content:
			"We offer a wide range of soft drinks including classic sodas, fruit-infused drinks, and more.",
	},
	{
		title: "What is the minimum order requirement",
		content:
			"We offer a wide range of soft drinks including classic sodas, fruit-infused drinks, and more.",
	},
	{
		title: "How can I place an order",
		content:
			"We offer a wide range of soft drinks including classic sodas, fruit-infused drinks, and more.",
	},
	{
		title: "Can I request specific brands or flavors",
		content:
			"We offer a wide range of soft drinks including classic sodas, fruit-infused drinks, and more.",
	},
	{
		title: "Do you have a return policy",
		content:
			"We offer a wide range of soft drinks including classic sodas, fruit-infused drinks, and more.",
	},
];

export const footerNavItems = [
	{
		imgSrc: "/svgs/fb.svg",
		link: "https://www.facebook.com/SippyLife",
	},
	{
		imgSrc: "/svgs/Instagram.svg",
		link: "https://www.instagram.com/sippy_official",
	},
	{
		imgSrc: "/svgs/Twitter.svg",
		link: "https://www.x.com/Sippy_Life",
	},
	{
		imgSrc: "/svgs/Youtube.svg",
		link: "https://www.youtube.com/@SippyLife",
	},
	{
		imgSrc: "/svgs/whatsapp.svg",
		link: "https://wa.me/2348161185271",
	},
	{
		imgSrc: "/svgs/linkedIn.svg",
		link: "https://www.linkedin.com/company/sippy-life",
	},
];
